export default {
  h1: {
    mt: [3, null, 5],
    mb: [4, null, 5]
  },
  p: {
    fontSize: 3
  }
};
